import { contactInfo } from '../data/portfolio';

declare global {
  interface Window {
    Cal?: (...args: unknown[]) => void;
  }
}

// Cal.com embed is loaded in public/index.html
export const openCalendar = () => {
  window.Cal?.("modal", {
    calLink: contactInfo.calLink,
    config: { layout: "month_view" },
  });
};
